import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { AvatarModule } from 'ngx-avatars';
import { EnvironmentService } from '../../../services/environment.service';
import { of } from 'rxjs';

@Component({
  selector: 'adf-user-menu',
  standalone: true,
  imports: [CommonModule, NgbDropdownModule, AvatarModule, TranslateModule],
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserMenuComponent {
  private _router = inject(Router);
  private _environmentService = inject(EnvironmentService);

  @Output() logout = new EventEmitter<void>();
  @Input() userDisplayName!: string | null;

  isOnline = navigator.onLine;;

  onLogout() {
    this.logout.emit();
  }

  onSettings() {
    this._router.navigateByUrl('/application-settings');
  }
}
